import React from 'react';

import { useHeaderStyles } from './header.style';
import { createSlots } from './slots';

const { slots, useSlots } = createSlots('Header', ['actions'] as const);

export interface HeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const HeaderBase: React.FC<HeaderProps> = ({ title, subtitle, children }) => {
  const { actions } = useSlots(children);
  const styles = useHeaderStyles();

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
      <div className={styles.right}>{actions}</div>
    </div>
  );
};

export const Header = Object.assign(HeaderBase, {
  Actions: slots.Actions,
});
